import { Injectable } from '@angular/core';
import { SharedService } from 'src/app/layouts/shared-service';
import { AcukwikAirport } from 'src/app/models/AcukwikAirport';
import { FlightWatchMapWrapperComponent } from '../flight-watch-map-wrapper/flight-watch-map-wrapper.component';
import { BETA_MAP_FBOS_ALLOWED } from '../config/flight-watch.config';
import { normalizeString } from '../utils/string.utils';
import * as SharedEvents from 'src/app/constants/sharedEvents';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';

@Injectable({
    providedIn: 'root'
})
export class FlightWatchIcaoService {
    constructor() {}

    /**
     * Determines if the map toggle button should be visible based on ICAO and FBO
     * @param selectedICAO - Selected ICAO code
     * @param fboName - FBO name
     * @returns True if toggle button should be visible
     */
    getMapToogleButtonState(selectedICAO: string, fboName: string | null): boolean {
        const normalizedIcao = normalizeString(selectedICAO);
        const normalizedFboName = normalizeString(fboName);

        return BETA_MAP_FBOS_ALLOWED.some((config) => {
            const normalizedConfigIcao = normalizeString(config.icao);
            const icaoMatches = normalizedConfigIcao === normalizedIcao;

            if (!icaoMatches) {
                return false;
            }

            // If no FBO restriction, ICAO match is sufficient
            if (!config.fbos || config.fbos.length === 0) {
                return true;
            }

            // If FBO restriction exists, check if FBO name matches
            return config.fbos.some((fbo) => normalizeString(fbo) === normalizedFboName);
        });
    }

    /**
     * Updates the ICAO and synchronizes with map and shared service
     * @param icao - New ICAO code
     * @param mapWrapper - Map wrapper component
     * @param sharedService - Shared service for state management
     */
    updateIcao(
        icao: string,
        mapWrapper: FlightWatchMapWrapperComponent,
        sharedService: SharedService
    ): void {
        // Update localStorage and shared service state
        sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.icao, icao);

        // Update map
        mapWrapper.map.goToAirport(icao);
        mapWrapper.map.updateICAOIconOnMap(icao);

        // Emit change event
        sharedService.emitChange(SharedEvents.icaoChangedEvent);
    }

    /**
     * Extracts ICAO list from airport list
     * @param airportList - List of airports
     * @returns Array of ICAO codes
     */
    setIcaoList(airportList: AcukwikAirport[]): string[] {
        return airportList.map((airport) => airport.icao);
    }
}

